import createConnectedRouter from './connected-router';
import createConnectRouter from './reducer';
import plainStructure from './structure/plain';

export {default as routerMiddleware} from './middleware';

export const ConnectedRouter = createConnectedRouter(plainStructure);
export const connectRouter = createConnectRouter(plainStructure);
